export enum InfluxColors {
  // Greys
  Obsidian = '#0f0e15',
  Raven = '#181820',
  Kevlar = '#202028',
  Castle = '#292933',
  Onyx = '#31313d',
  Pepper = '#383846',
  Smoke = '#434453',
  Graphite = '#545667',
  Storm = '#676978',
  Mountain = '#757888',
  Wolf = '#8e91a1',
  Sidewalk = '#999dab',
  Forge = '#a4a8b6',
  Mist = '#bec2cc',
  Chromium = '#c6cad3',
  Platinum = '#d4d7dd',
  Pearl = '#e7e8eb',
  Whisper = '#eeeff2',
  Cloud = '#f6f6f8',
  Ghost = '#fafafc',
  White = '#ffffff',
  // Blues
  Abyss = '#120653',
  Sapphire = '#0b3a8d',
  Ocean = '#066fc5',
  Pool = '#00a3ff',
  Laser = '#00C9FF',
  Hydrogen = '#6BDFFF',
  Neutrino = '#BEF0FF',
  Yeti = '#F0FCFF',
  // Purples
  Shadow = '#2b007e',
  Void = '#5c10a0',
  Amethyst = '#8e1fc3',
  Star = '#be2ee4',
  Comet = '#ce58eb',
  Potassium = '#dd84f1',
  Moonstone = '#ebadf8',
  Twilight = '#fad9ff',
  // Greens
  Gypsy = '#003e34',
  Emerald = '#006f49',
  Viridian = '#009f5f',
  Rainforest = '#34bb55',
  Honeydew = '#67d74e',
  Krypton = '#9bf445',
  Wasabi = '#c6f98e',
  Mint = '#f3ffd6',
  // Yellows
  Oak = '#3F241F',
  Topaz = '#E85B1C',
  Tiger = '#F48D38',
  Pineapple = '#FFB94A',
  Thunder = '#FFD255',
  Sulfur = '#FFE480',
  Daisy = '#FFF6B8',
  Banana = '#FFFDDE',
  // Reds
  Basalt = '#2F1F29',
  Ruby = '#BF3D5E',
  Fire = '#DC4E58',
  Curacao = '#F95F53',
  Dreamsicle = '#FF8564',
  Tungsten = '#FFB6A0',
  Marmelade = '#FFDCCF',
  Flan = '#FFF7F4',
  // Brand Colors
  Chartreuse = '#D6F622',
  DeepPurple = '#13002D',
  Magenta = '#BF2FE5',
  Galaxy = '#9394FF',
  Pulsar = '#513CC6',
}

export const VIRIDIS = [
  '#440154',
  '#481f70',
  '#443983',
  '#3b528b',
  '#31688e',
  '#287c8e',
  '#21918c',
  '#20a486',
  '#35b779',
  '#5ec962',
  '#90d743',
  '#c8e020',
]

export const MAGMA = [
  '#000004',
  '#100b2d',
  '#2c115f',
  '#51127c',
  '#721f81',
  '#932b80',
  '#b73779',
  '#d8456c',
  '#f1605d',
  '#fc8961',
  '#feb078',
  '#fed799',
]

export const INFERNO = [
  '#000004',
  '#110a30',
  '#320a5e',
  '#57106e',
  '#781c6d',
  '#9a2865',
  '#bc3754',
  '#d84c3e',
  '#ed6925',
  '#f98e09',
  '#fbb61a',
  '#f4df53',
]

export const PLASMA = [
  '#0d0887',
  '#3a049a',
  '#5c01a6',
  '#7e03a8',
  '#9c179e',
  '#b52f8c',
  '#cc4778',
  '#de5f65',
  '#ed7953',
  '#f89540',
  '#fdb42f',
  '#fbd524',
]

export const YL_OR_RD = [
  '#ffffcc',
  '#ffeda0',
  '#fed976',
  '#feb24c',
  '#fd8d3c',
  '#fc4e2a',
  '#e31a1c',
  '#bd0026',
  '#800026',
]

export const YL_GN_BU = [
  '#ffffd9',
  '#edf8b1',
  '#c7e9b4',
  '#7fcdbb',
  '#41b6c4',
  '#1d91c0',
  '#225ea8',
  '#253494',
  '#081d58',
]

export const BU_GN = [
  '#f7fcfd',
  '#ebf7fa',
  '#dcf2f2',
  '#c8eae4',
  '#aadfd2',
  '#88d1bc',
  '#68c2a3',
  '#4eb485',
  '#37a266',
  '#228c49',
  '#0d7635',
  '#025f27',
]

// Chronograf Colors
export const NINETEEN_EIGHTY_FOUR = ['#31C0F6', '#BC00B8', '#FF7E27']
export const ATLANTIS = ['#74D495', '#4949EA', '#FF4D9E']
export const DO_ANDROIDS_DREAM = ['#8F8AF4', '#A51414', '#F4CF31']
export const DELOREAN = ['#FD7A5D', '#5F1CF2', '#4CE09A']
export const CTHULHU = ['#FDC44F', '#007C76', '#8983FF']
export const ECTOPLASM = ['#DA6FF1', '#00717A', '#ACFF76']
export const PRIMARY = ['#00A3FF', '#67D74E', '#FFD255', '#DC4E58']
export const PRIMARY_REVERSE = ['#DC4E58', '#FFD255', '#67D74E', '#00A3FF']
export const T_MAX_400_FILM = ['#F6F6F8', '#A4A8B6', '#545667']
export const RAINBOW_EIGHT = [
  '#00f8ff',
  '#33a8ff',
  '#784dff',
  '#da07ff',
  '#FF0000',
  '#FFC200',
  '#85F700',
  '#00b15d',
]
export const RAINBOW_SIXTEEN = [
  '#4dfaff',
  '#00adb2',
  '#71c2ff',
  '#2475b2',
  '#a183ff',
  '#5436b2',
  '#e552ff',
  '#9805b2',
  '#ff4d4d',
  '#b20000',
  '#ffd44d',
  '#b28700',
  '#aaf94d',
  '#5dac00',
  '#4dc98e',
  '#007c41',
]
export const COLOR_BLIND_FRIENDLY_DARK = [
  '#000000',
  '#E69F00',
  '#56B4E9',
  '#009E73',
  '#F0E442',
  '#0072B2',
  '#D55E00',
  '#CC79A7',
]

export const COLOR_BLIND_FRIENDLY_LIGHT = [
  '#FFFFFF',
  '#E69F00',
  '#56B4E9',
  '#009E73',
  '#F0E442',
  '#0072B2',
  '#D55E00',
  '#CC79A7',
]

// Solid Colors
export const SOLID_RED = ['#DC4E58', '#DC4E58', '#DC4E58']
export const SOLID_YELLOW = ['#FFD255', '#FFD255', '#FFD255']
export const SOLID_GREEN = ['#67D74E', '#67D74E', '#67D74E']
export const SOLID_BLUE = ['#00A3FF', '#00A3FF', '#00A3FF']
export const SOLID_PURPLE = ['#BE2EE4', '#BE2EE4', '#BE2EE4']
